import { useState } from 'react';
import CapabilitiesHeader from './components/CapabilitiesHeader';
import CapabilitiesHero from './components/CapabilitiesHero';
import ComplianceLoopSection from './components/ComplianceLoopSection';
import PlatformArchitecture from './components/PlatformArchitecture';
import ProductFormTabs from './components/ProductFormTabs';
import SelectionGuide from './components/SelectionGuide';
import AddonCardsSection from './components/AddonCardsSection';
import DeliverablesShowcase from './components/DeliverablesShowcase';
import VersionRecommender from './components/VersionRecommender';
import FAQAccordion from './components/FAQAccordion';
import Footer from '../home/components/Footer';
import CapConsultationDrawer from './components/CapConsultationDrawer';
import StickyCTA from './components/StickyCTA';
import { BizTab } from './types';

export default function CapabilitiesPage() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerDefaultTab, setDrawerDefaultTab] = useState<BizTab>('9810');
  const [drawerDefaultNote, setDrawerDefaultNote] = useState('');
  const [drawerDefaultNeedTax, setDrawerDefaultNeedTax] = useState(false);

  const handleOpenDrawer = (source?: string, needTax?: boolean) => {
    if (source) setDrawerDefaultNote(source);
    if (needTax !== undefined) setDrawerDefaultNeedTax(needTax);
    setDrawerOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <CapabilitiesHeader />
      <CapabilitiesHero onOpenDrawer={() => handleOpenDrawer()} />
      <ComplianceLoopSection />
      <PlatformArchitecture />
      <ProductFormTabs onOpenDrawer={handleOpenDrawer} />
      <SelectionGuide onOpenDrawer={handleOpenDrawer} />
      <AddonCardsSection />
      <DeliverablesShowcase />
      <VersionRecommender onOpenDrawer={handleOpenDrawer} />
      <FAQAccordion />
      <Footer />
      <CapConsultationDrawer 
        open={drawerOpen} 
        onClose={() => setDrawerOpen(false)}
        defaultTab={drawerDefaultTab}
        defaultNote={drawerDefaultNote}
        defaultNeedTax={drawerDefaultNeedTax}
      />
      <StickyCTA onOpenDrawer={() => handleOpenDrawer()} />
    </div>
  );
}